/** Whether an in-progress drag carries files (vs. text/other), used to gate file drop targets. */
export function dragEventHasFiles(dataTransfer: DataTransfer | null): boolean {
  if (!dataTransfer) return false;
  return Array.from(dataTransfer.types ?? []).includes("Files");
}

function fileExtension(file: File): string | null {
  const name = file.name.trim().toLowerCase();
  if (!name.includes(".")) return null;
  return name.split(".").pop() ?? null;
}

/** Keep only files whose extension or MIME type matches an `accept` list. */
export function filterAcceptedFiles(files: File[], accept?: string): File[] {
  if (!accept) return files;
  const patterns = accept
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
  if (patterns.length === 0) return files;
  return files.filter((file) => {
    const extension = fileExtension(file);
    const mimeType = file.type.toLowerCase();
    return patterns.some((pattern) => {
      const normalizedPattern = pattern.toLowerCase();
      if (normalizedPattern.startsWith(".")) {
        return extension === normalizedPattern.slice(1);
      }
      return normalizedPattern.endsWith("/*")
        ? mimeType.startsWith(normalizedPattern.slice(0, -1))
        : mimeType === normalizedPattern;
    });
  });
}
